import { fetch } from '@/js/fetch';

export default {
    name: 'global',
    store() {
        return {
            isMobileMenuVisible: false,
            isMinicartVisible: false,
            isPredictiveSearchVisible: false,
            isWindowScrolled: false,
            cart: null,
            isDark: false,
            srupMenu: false,
            activeSection: 'releasit',
            isHeaderHidden: false,
            appPage: {
                activeCategoryTab: 'All',
                activeCategory: '',
                activeTab: 0,
                predictiveSearchQuery: ''
            },
            solutionsPageSelectedSlide: 0,
            init() {
                console.log('Groundwork Global Store Initialized.');

                window.addEventListener('scroll', this.onWindowScrollHandler.bind(this));

                this.initLiquidAJaxCart();
            },
            get bodyClasses() {
                let classes = [];

                if (this.isMobileMenuVisible) {
                    classes.push('mobile-menu-visible');
                }

                return classes || '';
            },
            openMobileMenu() {
                this.isMobileMenuVisible = true;
            },
            closeMobileMenu() {
                this.isMobileMenuVisible = false;
            },
            toggleMobileMenu() {
                this.isMobileMenuVisible = !this.isMobileMenuVisible;
            },
            toggleDarkMode() {
                this.isDark = !this.isDark;
            },
            toggleSrupMenu() {
                this.srupMenu = !this.srupMenu;
            },
            initLiquidAJaxCart() {
                document.addEventListener('liquid-ajax-cart:request-end', event => {
                    const { requestState, cart, previousCart, sections } = event.detail;

                    if (requestState.requestType === 'add') {
                        if (requestState.responseData?.ok) {
                            this.isMinicartVisible = true;
                        }
                    }

                    this.cart = cart;
                });
            },
            onWindowScrollHandler() {
                const isScrolled = window.scrollY > 0;

                this.isWindowScrolled = isScrolled;
                document.body.classList[isScrolled ? 'add' : 'remove']('scrolled');
            },
            scrollToTop() {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            },
            fetch: fetch
        };
    }
};
